import {
    Model
} from '@vuex-orm/core'
import ArrayAttr from './ArrayAttr'
import ObjAttr from './ObjAttr'
import OptionalAttr from './OptionalAttr'

export default class BaseModel extends Model {
    
    static array (value, keys) {
        return new ArrayAttr(this,
            value,
            keys)
    }

    static obj (value, schema) {
        return new ObjAttr(this,
            value,
            schema)
    }

    static optional (value, schema) {
        return new OptionalAttr(this, value, schema)
    }

    static findUuid(uuid) {
        return this.query()
            .where('uuid', uuid)
            .withAllRecursive()
            .first()
    }
}